import { worklist } from 'modules/analytics/constants';
import { marks } from './marks';

export const measures = Object.freeze({
  worklist: {
    load: {
      timeToRequest: {
        metricName: worklist.sys.loadRequestFired,
        startMarkName: marks.worklist.load.start,
        endMarkName: marks.worklist.load.request_fired,
      },
      timeToDataReady: {
        metricName: worklist.sys.loadDataReady,
        startMarkName: marks.worklist.load.start,
        endMarkName: marks.worklist.load.data_ready,
      },
      timeToPaint: {
        metricName: worklist.sys.loadPaint,
        startMarkName: marks.worklist.load.start,
        endMarkName: marks.worklist.load.paint,
      },
    },
    pagination: {
      timeToRequest: {
        metricName: worklist.sys.paginationRequestFired,
        startMarkName: marks.worklist.pagination.start,
        endMarkName: marks.worklist.pagination.request_fired,
      },
      timeToDataReady: {
        metricName: worklist.sys.paginationDataReady,
        startMarkName: marks.worklist.pagination.start,
        endMarkName: marks.worklist.pagination.data_ready,
      },
      timeToPaint: {
        metricName: worklist.sys.paginationPaint,
        startMarkName: marks.worklist.pagination.start,
        endMarkName: marks.worklist.pagination.paint,
      },
    },
    patientJacket: {
      timeToWorklistItemData: {
        metricName: worklist.sys.patientJacketWorklistItemFetch,
        startMarkName: marks.worklist.patient_jacket.start,
        endMarkName: marks.worklist.patient_jacket.worklist_item_fetch,
      },
      timeToSelectedPriorLoad: {
        metricName: worklist.sys.patientJacketSelectedPriorLoad,
        startMarkName: marks.worklist.patient_jacket.select_prior,
        endMarkName: marks.worklist.patient_jacket.selected_prior_load,
      },
      timeToSelectedPriorPaint: {
        metricName: worklist.sys.patientJacketSelectedPriorPaint,
        startMarkName: marks.worklist.patient_jacket.select_prior,
        endMarkName: marks.worklist.patient_jacket.selected_prior_paint,
      },
      timeToPaint: {
        metricName: worklist.sys.patientJacketPaint,
        startMarkName: marks.worklist.patient_jacket.start,
        endMarkName: marks.worklist.patient_jacket.paint,
      },
      timeToPriorsSummaryPaint: {
        metricName: worklist.sys.patientJacketPriorsSummaryPaint,
        startMarkName: marks.worklist.patient_jacket.priors_summary_start,
        endMarkName: marks.worklist.patient_jacket.priors_summary_paint,
      },
      timeToPriorsSummaryLoad: {
        metricName: worklist.sys.patientJacketPriorsSummaryLoad,
        startMarkName: marks.worklist.patient_jacket.priors_summary_start,
        endMarkName: marks.worklist.patient_jacket.priors_summary_load,
      },
    },
    crud: {
      timeToAbandon: {
        metricName: worklist.sys.crudAbandon,
        startMarkName: marks.worklist.crud.open_dialog,
        endMarkName: marks.worklist.crud.abandon,
      },
      timeToSubmit: {
        metricName: worklist.sys.crudSubmit,
        startMarkName: marks.worklist.crud.open_dialog,
        endMarkName: marks.worklist.crud.submit,
      },
      timeToSave: {
        metricName: worklist.sys.crudSave,
        startMarkName: marks.worklist.crud.open_dialog,
        endMarkName: marks.worklist.crud.save,
      },
      timeToDelete: {
        metricName: worklist.sys.crudDelete,
        startMarkName: marks.worklist.crud.open_delete_dialog,
        endMarkName: marks.worklist.crud.delete,
      },
    },
    columns: {
      timeToResize: {
        metricName: worklist.sys.columnResize,
        startMarkName: marks.worklist.columns.resize_start,
        endMarkName: marks.worklist.columns.resize_end,
      },
      timeToResizeSave: {
        metricName: worklist.sys.columnResizeSave,
        startMarkName: marks.worklist.columns.resize_save_start,
        endMarkName: marks.worklist.columns.resize_save_end,
      },
      timeToAdjustColumns: {
        metricName: worklist.sys.adjustColumns,
        startMarkName: marks.worklist.columns.adjust_start,
        endMarkName: marks.worklist.columns.adjust_save,
      },
      timeToAdjustColumnsPaint: {
        metricName: worklist.sys.adjustColumnsPaint,
        startMarkName: marks.worklist.columns.adjust_start,
        endMarkName: marks.worklist.columns.adjust_paint,
      },
      timeToPin: {
        metricName: worklist.sys.columnPin,
        startMarkName: marks.worklist.columns.pin_start,
        endMarkName: marks.worklist.columns.pin_save,
      },
      timeToPinPaint: {
        metricName: worklist.sys.columnPinPaint,
        startMarkName: marks.worklist.columns.pin_start,
        endMarkName: marks.worklist.columns.pin_paint,
      },
      timeToReorder: {
        metricName: worklist.sys.columnReorder,
        startMarkName: marks.worklist.columns.reorder_start,
        endMarkName: marks.worklist.columns.reorder_save,
      },
      timeToReorderPaint: {
        metricName: worklist.sys.columnReorderPaint,
        startMarkName: marks.worklist.columns.reorder_start,
        endMarkName: marks.worklist.columns.reorder_paint,
      },
    },
    drawer: {
      timeToOpenPaint: {
        metricName: worklist.sys.drawerOpenPaint,
        startMarkName: marks.worklist.drawer.open_start,
        endMarkName: marks.worklist.drawer.open_paint,
      },
    },
  },
} as const);
